import { render, staticRenderFns } from "./uninjuryManage.vue?vue&type=template&id=2a47a4ec"
import script from "./uninjuryManage.vue?vue&type=script&lang=js"
export * from "./uninjuryManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a47a4ec')) {
      api.createRecord('2a47a4ec', component.options)
    } else {
      api.reload('2a47a4ec', component.options)
    }
    module.hot.accept("./uninjuryManage.vue?vue&type=template&id=2a47a4ec", function () {
      api.rerender('2a47a4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/noaccident/uninjuryManage.vue"
export default component.exports